import React, { Component } from 'react';
import Wrapper from '../common/Wrapper';
import { MenuItem} from 'react-bootstrap'
import history from '../../history';
import PropTypes from 'prop-types'
import { routesUrls } from '../../settings/routes';
import Question from '../Question';

class CustomItems extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  render() {
    const {formatMessage} = this.context;
    return <React.Fragment>
      <MenuItem
        onClick={() => {
          history.push(routesUrls.dashboard)
        }}
      >{formatMessage('navTitleDashboard')}</MenuItem>
      {/* <MenuItem
        onClick={() => {
          history.push(routesUrls.presentations)
        }}
      >{formatMessage('navTitleCard')}</MenuItem> */}
   </React.Fragment>
  }
}

const QuestionPage = (props) => {
  return <Wrapper 
    renderButtonNav = {false}
    CustomItems={CustomItems}
  >
    <Question {...props} />
  </Wrapper>
}

export default QuestionPage;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/QuestionPage.js